var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shops-nav hidden-lg-and-down"},[_c('div',{staticClass:"information"}),_c('div',{staticClass:"classification"})])
}]

export { render, staticRenderFns }